import React, { useEffect, useState } from "react";
import { Box, Typography, Paper, Grid, Card, CardContent } from "@mui/material";

import { API_URL } from "../utils/config";
const GradeComponent = () => {
  const [dataGrades, setDataGrades] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [department, setDepartment] = useState("");

  useEffect(() => {
    const fetchAverageMarks = async () => {
      const token = localStorage.getItem("token") || "";
      const userId = localStorage.getItem("userId") || "";

      try {
        const requestOptions = {
          method: "GET",
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        };

        const response = await fetch(
          `${API_URL}/average-marks/${userId}`,
          requestOptions
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        const formattedData = result.data.map((item) => ({
          courseName: item.courseName || "Unknown Course", // Limit course name length
          grade: item.averageMarks, // Use average marks as grade
          semester: item.semester || "N/A", // Add semester if available
        }));

        const departmentResponse = await fetch(
          `${API_URL}/user-department/${userId}`,
          {
            method: "GET",
            headers: {
              Authorization: token,
              "Content-Type": "application/json",
            },
          }
        );

        if (!departmentResponse.ok) {
          throw new Error(`HTTP error! status: ${departmentResponse.status}`);
        }

        const departmentResult = await departmentResponse.json();
        setDepartment(departmentResult.department);

        setDataGrades(formattedData);
        setLoading(false);
      } catch (err) {
        setError("Failed to fetch data");
        setLoading(false);
      }
    };

    fetchAverageMarks();
  }, []);

  // Get unique semesters from the data
  const semesters = [...new Set(dataGrades.map((grade) => grade.semester))];

  return (
    <Box sx={{ padding: 3 }}>
      <Typography
        variant="h4"
        sx={{
          mb: 3,
          fontWeight: "bold",
          background: "#E1BA66",
          borderRadius: 1.5,
        }}
      >
        Your Scores Across All FLP Levels
      </Typography>

      {loading ? (
        <Typography variant="body1">Loading...</Typography>
      ) : error ? (
        <Typography variant="body1" color="error">
          {error}
        </Typography>
      ) : (
        semesters.map((semester) => (
          <Paper
            key={semester}
            sx={{ padding: 3, marginBottom: 3, borderRadius: 4 }}
          >
            <Typography
              variant="h5"
              sx={{ marginBottom: 2, fontWeight: "bold" }}
            >
              Level: {department}
            </Typography>
            <Grid container spacing={2}>
              {dataGrades
                .filter((grade) => grade.semester === semester)
                .map((course, index) => {
                  // Array of different background colors for each card
                  const bgColors = [
                    // "#000000", // Black
                    "#6A5ACD", // Slate Blue
                    "#00C49F", // Teal
                    "#FF8042", // Orange
                    "#4363d8", // Blue
                    "#e6194B", // Red
                    // "#880E4F", // Pink
                    // "#B71C1C", // Red
                    // "#3E2723", // Brown
                    // "#004D40", // Teal
                    // "#1B5E20", // Green
                    // "#33691E", // Light Green
                  ];

                  // Get color based on index
                  const bgColor = bgColors[index % bgColors.length];

                  return (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                      <Card
                        sx={{
                          borderRadius: 4,
                          bgcolor: bgColor,
                          color: "#E1BA66",
                          transition: "transform 0.3s",
                          "&:hover": {
                            transform: "translateY(-5px)",
                            boxShadow: 6,
                          },
                        }}
                      >
                        <CardContent>
                          <Typography variant="h6" sx={{ color: "#E1BA66" }}>
                            {course.courseName}
                          </Typography>
                          <Typography variant="body1" sx={{ color: "#E1BA66" }}>
                            Grade: {course.grade}
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                  );
                })}
            </Grid>
          </Paper>
        ))
      )}
    </Box>
  );
};

export default GradeComponent;
